import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import {
  CandidacyPlacement,
  HttpResponse,
  UpdateCandidacyPlacementRequest,
} from "@/types";

export function useUpdatePlacementById() {
  const mutation = useMutation({
    mutationFn: async ({
      companyId,
      id,
      jobId,
      updatePlacementRequest,
    }: {
      companyId: string;
      id: number;
      jobId: string;
      updatePlacementRequest: UpdateCandidacyPlacementRequest;
    }) => {
      const path = `companies/${companyId}/jobs/${jobId}/placements/${id.toString()}`;
      const res = await guacHttpClient.patch<
        CandidacyPlacement,
        HttpResponse<CandidacyPlacement>,
        UpdateCandidacyPlacementRequest
      >(path, updatePlacementRequest);

      return res.data;
    },
  });

  return mutation;
}
